import { FC } from 'react';

export const NativeAuthLMfaPage: FC = () => {
    return <></>;
};
